import(/* webpackMode: "eager" */ "/codebuild/output/src2299251357/src/ui-directo/apps/commerce/src/app/error.tsx");
